import React, { Component, useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import { t } from '../../../locales/i18n';
import { Link } from 'react-router-dom';

import { setSettings, SettingsState } from '../index';
import { getAppSettings } from '../../../utils/storage';

import { InputWrapper } from '../../../components/forms/input-wrapper';
import { Input, Select, Button } from 'semantic-ui-react';
import { Segment } from '../../../components/segment';
import {
  HeroContainer,
  AppContent,
  HeroFooter,
  HeroHeader
} from '../../../components/layout/layout-components';

interface SettingsPageProps {}
export function SettingsPage(props: SettingsPageProps) {
  const dispatch = useDispatch();

  const [boothId, setBoothId] = useState('');
  const [boothSecret, setBoothSecret] = useState('');
  const [notifications, setNotifications] = useState('off');

  useEffect(() => {
    (async () => {
      const settings = await getAppSettings();
      setBoothId(settings.boothId);
      setBoothSecret(settings.boothSecret);
      setNotifications(settings.notifications);
    })();
  }, [getAppSettings]);

  return (
    <HeroContainer>
      <HeroHeader>
        <h1>{t('settingsPage.settings')}</h1>
      </HeroHeader>
      <AppContent>
        <Segment>
          <InputWrapper
            helperText={t('settingsPage.boothId.hintText')}
            label={t('settingsPage.boothId.floatingLabel')}
          >
            <Input
              onChange={(event) => setBoothId(event.target.value)}
              value={boothId || ''}
            />
          </InputWrapper>

          <InputWrapper
            helperText={t('settingsPage.boothSecret.hintText')}
            label={t('settingsPage.boothSecret.floatingLabel')}
          >
            <Input
              onChange={(event) => setBoothSecret(event.target.value)}
              value={boothSecret || ''}
            />
          </InputWrapper>

          <InputWrapper
            helperText={t('settingsPage.notifications.hintText')}
            label={t('settingsPage.notifications')}
          >
            <Select
              value={notifications || ''}
              onChange={(_event: any, { value }) =>
                setNotifications(value as string)
              }
              margin="normal"
              options={[
                { value: 'off', key: 'off', text: t('notifications.off') },
                {
                  value: 'sound.doorBell',
                  key: 'sound.doorBell',
                  text: t('notifications.sound.doorBell')
                }
              ]}
            />
          </InputWrapper>
        </Segment>
      </AppContent>
      <HeroFooter>
        <Link to="/">
          <Button>{t('back')}</Button>
        </Link>
        <Button
          primary
          onClick={() =>
            dispatch(
              setSettings(
                {
                  boothId,
                  boothSecret,
                  notifications
                },
                {}
              )
            )
          }
        >
          {t('save')}
        </Button>
      </HeroFooter>
    </HeroContainer>
  );
}
